import React from 'react';
import PropTypes from 'prop-types';
import { Accordion } from './Accordion';
import './Accordion.scss';

const AccordionList = ({ data, colorSetting }) => {
  return (
    <div className="accordion-list">
      {data.values.map((item, index) => (
        item?.description?.value ? (
          <Accordion
            key={index}
            title={item?.title?.value}
            description={item?.description?.value}
            viewMore={item?.viewMore?.value}
            viewLess={item?.viewLess?.value}
            startOpen={false}
            backgroundColor={colorSetting}
            subtitle={item?.subtitle?.value}
          />
        ) : null
      ))}
    </div>
  );
};

AccordionList.propTypes = {
  data: PropTypes.shape({
    values: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.shape({
          value: PropTypes.string.isRequired,
        }),
        description: PropTypes.shape({
          value: PropTypes.shape({
            text: PropTypes.shape({
              value: PropTypes.string.isRequired,
            }),
          }),
        }),
        viewMore: PropTypes.shape({
          value: PropTypes.string,
        }),
        viewLess: PropTypes.shape({
          value: PropTypes.string,
        }),
      })
    ),
  }).isRequired,
};

export { AccordionList };
